import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { UserService } from './user.service';
import { switchMap, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ProductoService } from './producto.service';


@Injectable({
  providedIn: 'root'
})
export class GatewayService {

  constructor(private http: HttpClient,
              private userService: UserService,
              private router: Router,
              private productoService: ProductoService) {

  }

  get<T>(url: string, params: any, secure: boolean): Observable<T> {
    return this.userService.getAccessToken(secure).pipe(switchMap(accessToken => {
      const headers = this.AddHeaders(secure, accessToken);
      return this.http.get<T>(url, {
        headers,
        params
      });
    }), catchError(err => {
        if (err.status == 401){
          this.userService.logout();
          this.router.navigate(['/login', this.productoService.getCurrentApp()]);
        }
        return throwError(err);
    }));
  }

  post<T>(url: string, body: any, secure: boolean): Observable<T> {
    return this.userService.getAccessToken(secure).pipe(switchMap(accessToken => {
      const headers = this.AddHeaders(secure, accessToken);
      return this.http.post<T>(url, body, {
        headers
      });
    }));
  }

  private AddHeaders(secure: boolean, accessToken: string) {
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    if (secure) {
      headers = headers.append('Authorization', 'Bearer ' + accessToken);
    }
    return headers;
  }
}
